import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { CATEGORY_ICON, DEFAULT_CATEGORY_ICON } from '../../../elements/data/categoryVisuals.js';

export function CategoryLabel({ category }: { category: string }): ReactNode {
  const theme = useTheme();
  const Icon = CATEGORY_ICON[category] ?? DEFAULT_CATEGORY_ICON;
  const accent = theme.palette.elementCategory[category] ?? theme.palette.elementCategory.default;
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1.5, color: accent }}>
      <Icon sx={{ fontSize: 16 }} />
      <Typography
        component="span"
        sx={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase' }}
      >
        {category}
      </Typography>
    </Box>
  );
}
